import React, { useState } from 'react';
import { CardWrapper } from './styles';
import { Button, Modal, Space } from 'antd';
import { t } from 'i18next';
import { useDispatch } from '@redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { DynamicObjectType } from 'types/commons';
import CancelModal from '../components/Modal/CancelModal';
import {
  confirmOrder,
  getByIdOrdersTabTryBuy,
} from '@redux/ordersTabTryBuy/actions';
import { getAllOrderHistories } from '@redux/orderHistories/actions';

const { confirm } = Modal;

const JOIN = [
  'orderBatch',
  'shop',
  'orderItems',
  'transferOrders||id,toId,status,fromWarehouseId,toWarehouseId',
  'orderShipping',
];

const Validation = ({ data }) => {
  const dispatch = useDispatch();

  const [cancelVisible, setCancelVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(true);

  const getOrderDetail = () => {
    dispatch(
      getByIdOrdersTabTryBuy({
        data: {
          id: data?.id,
        },
        options: {
          isRequestApi: true,
          isRefresh: true,
          extraParams: {
            join: JOIN,
          },
        },
      }),
    );
  };

  const getHistories = () => {
    dispatch(
      getAllOrderHistories({
        data: {
          pageSize: 100,
          join: ['creator'],
          filters: [
            {
              condition: 'and',
              key: 'orderId',
              value: data?.id,
              operator: 'eq',
            },
          ],
          orderBy: '-createdAt',
        },
        options: {
          isRefresh: true,
        },
      }),
    );
  };

  const handleConfirmOrder = async () => {
    setLoading(true);
    try {
      const res = await dispatch(
        confirmOrder({
          data: {
            id: data?.id,
          },
          options: {
            isShowSuccessNoti: true,
          },
        }),
      );
      if (res?.payload.success) {
        getOrderDetail();
        getHistories();
        setLoading(false);
        setConfirmVisible(false);
      }
    } catch {
      //
    }
  };

  const CHECK_LIST = [
    {
      text: 'ordersTabTryBuy.stockAvailable',
      key: 'enoughStock',
      isPassed: data?.hasStockAvailable,
    },
    {
      text: 'orders.isCustomerInBlackList',
      key: 'isCustomerInBlackList',
      isPassed: !data?.isCustomerInBlackList,
    },
    {
      text: 'orders.isSpamIn24h',
      key: 'isSpamIn24h',
      isPassed: !data?.isSpamIn24h,
    },
  ];

  return (
    <CardWrapper title="Validation">
      <Space size={10} direction="vertical">
        {CHECK_LIST.filter((i: DynamicObjectType) => !i?.hidden)?.map((e) => (
          <Space size={12} className="align-center" key={e.key}>
            {e.isPassed ? (
              <FontAwesomeIcon
                icon={faCircleCheck}
                style={{
                  color: '#88C041',
                  width: 20,
                  height: 20,
                  display: 'flex',
                  alignItems: 'center',
                }}
              />
            ) : (
              <FontAwesomeIcon
                icon={faCircleXmark}
                style={{
                  color: '#E20000',
                  width: 20,
                  height: 20,
                  display: 'flex',
                  alignItems: 'center',
                }}
              />
            )}
            <div>{t(e.text)}</div>
          </Space>
        ))}
      </Space>
      <div className="flex gap-5 w-full mt-2.5">
        <Button
          className="w-full h-[40px] btn-light"
          onClick={() => setCancelVisible(true)}
        >
          {t('button.cancel')}
        </Button>
        <Button
          type="primary"
          className="w-full h-[40px]"
          onClick={() => {
            confirm({
              open: confirmVisible,
              title: t('ordersTabTryBuy.detail.confirmAction'),
              content: !CHECK_LIST[0]?.isPassed ? (
                <div className="txt-error">
                  {t('orderDetail.warningOutOffStock')}
                </div>
              ) : (
                <div className="">
                  {t('ordersTabTryBuy.detail.approveOrder')}
                </div>
              ),
              okText: t('button.ok'),
              cancelText: t('button.cancel'),
              onOk: async () => {
                setLoading(true);
                await handleConfirmOrder();
              },
              onCancel: () => {},
              okButtonProps: {
                loading: !!loading,
              },
            });
          }}
        >
          {t('button.approve')}
        </Button>
      </div>
      {/* <ModalConfirmAction
        keyModal="confirmModal"
        title="ordersTabTryBuy.detail.confirmAction"
        description="ordersTabTryBuy.detail.approveOrder"
        handleConfirm={handleConfirmOrder}
        handleCancel={() => handleConfirmModal(false)}
        callback={() => {
          getOrderDetail();
          getHistories();
        }}
      /> */}
      <CancelModal
        visible={cancelVisible}
        onCancel={() => setCancelVisible(false)}
        {...data}
      />
    </CardWrapper>
  );
};

export default Validation;
